// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"485":"ca4be53c","821":"bb552444"}[chunkId] + ".chunk.css";
};